import { s as slot } from "../../../chunks/index2.js";
import "../../../chunks/index3.js";
/* empty css                                                           */
function _layout($$payload, $$props) {
  $$payload.out += `<div class="container mx-auto px-4 max-w-7xl"><div><div class="flex items-center gap-4"><h1 class="text-3xl font-bold"><!---->`;
  slot($$payload, $$props, "title", {});
  $$payload.out += `<!----></h1></div> <!---->`;
  slot($$payload, $$props, "default", {});
  $$payload.out += `<!----></div></div>`;
}
export {
  _layout as default
};
